"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserErrorResponseSchema", {
    enumerable: true,
    get: function() {
        return UserErrorResponseSchema;
    }
});
const _zod = require("zod");
const UserErrorResponseSchema = _zod.z.object({
    /**
	 * A friendly, high-level message describing what went wrong.
	 *
	 * This should be clear, human-readable, and suitable for end-user display.
	 * Example: "Some users already exist."
	 */ message: _zod.z.string(),
    /**
	 * Optional list of contextual details for the error.
	 *
	 * Example: if `message` is "Some users already exist", this might be
	 * ["email1@example.com", "email4@example.com"].
	 */ details: _zod.z.array(_zod.z.string()).optional(),
    /**
	 * Optional key-value pairs describing field-specific issues or additional context.
	 *
	 * This is typically used for:
	 * - Form validation errors mapped to specific fields
	 * - High-level, user-safe metadata (e.g., mappings or identifiers)
	 * - Guidance that can be displayed inline or in tooltips
	 *
	 * Examples:
	 * - { email: "Already in use", username: "Required" }
	 * - { mappingSource: "Field 'Employee ID' was mapped to 'ID' in the system" }
	 */ meta: _zod.z.record(_zod.z.string(), _zod.z.string()).optional()
});
